import { z } from "zod";

export const backofficeFindSiteNextModulationAvailabilityResponseSchema = z.void().or(z.coerce.date().nullish());

export type BackofficeFindSiteNextModulationAvailabilityResponse = z.infer<
  typeof backofficeFindSiteNextModulationAvailabilityResponseSchema
>;
